module.exports = __webpack_public_path__ + "img/pr-14.bde4ce31.png";